"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMinutes = void 0;
const p = (n) => (n > 1 ? "s" : "");
exports.formatMinutes = (mins) => {
    const iMins = typeof mins === "string" ? parseInt(mins, 10) : mins;
    if (iMins !== 0 && !iMins) {
        return "";
    }
    const hours = Math.floor(iMins / 60);
    const leftOverMinutes = iMins % 60;
    if (hours && leftOverMinutes) {
        return `${hours} hr${p(hours)} ${leftOverMinutes} min${p(leftOverMinutes)}`;
    }
    else if (hours) {
        return `${hours} hr${p(hours)}`;
    }
    else if (leftOverMinutes) {
        return `${leftOverMinutes} min${p(leftOverMinutes)}`;
    }
    return "0 min";
};
//# sourceMappingURL=formatMinutes.js.map